export default {
       hostname:'https://elearninguat.npccgodigital.com/api'
       //hostname:'https://apipreprod.npccgodigital.com/elearning'
      //hostname:'https://localhost:44338'
}